import { render } from "./EdmChangeSenderDialog.vue?vue&type=template&id=5aab3f0e"
import script from "./EdmChangeSenderDialog.vue?vue&type=script&lang=js"
export * from "./EdmChangeSenderDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__